import { yupResolver } from '@hookform/resolvers/yup';
import Fuse from 'fuse.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  FormProvider,
  SubmitErrorHandler,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import {
  FlatList,
  SafeAreaView,
  Text,
  TextInput as TextInput1,
  TouchableOpacity,
  View,
  StyleSheet,
  ScrollView,
  Dimensions,
} from 'react-native';
import Icon from '@react-native-vector-icons/fontawesome';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import {
  ShowToast,
  retrieveSetting,
  storeSetting,
  netState,
} from '../Common/common';
import BTButton from '../Components/BTButton';
import BTComboBox from '../Components/BTComboBox';
import { Col, Row } from '../Components/BTGrid';
import { TextInput } from '../Components/BTTextInput';
import { useGetEmployeesQuery } from '../redux/services/emmemployeeApi';
import { useGetPOAOutletsQuery } from '../redux/services/poaoutletApi';
import { useInsertPOEBillMutation } from '../redux/services/poebillApi';
import {
  useInsertPOEOrderMutation,
  useInsertPOEOrderIdemMutation,
  useUpdatePOEOrderMutation,
} from '../redux/services/poeorderApi';
import NetInfo from '@react-native-community/netinfo';
import { enqueueOrder, syncOfflineQueue } from '../Common/offlineOrderQueue';
import { useGetPOMGroupsQuery } from '../redux/services/pomgroupApi';
import { useGetAvailableExcessStockQuery } from '../redux/services/poeissueApi';
import { isOpenFoodProduct, excessCartKey } from '../Common/openFood';
import { useGetPOMProductsQuery } from '../redux/services/pomproductApi';
import { useGetPOMTablesQuery } from '../redux/services/pomtableApi';
import { RootState } from '../redux/store';
import {
  colors,
  spacing,
  shadows,
  borderRadius,
  typography,
} from '../theme/theme';

import T from '../Components/T';
import { tp } from '../utils/translateText';
interface item {
  pr_group?: number;
  pr_id: number;
  pr_name?: string;
  pr_srate: number;
  pr_qty: number;
  gr_discper: number;
  gr_discamt: number;
  gr_tax1per: number;
  gr_tax1amt: number;
  gr_tax2per: number;
  gr_tax2amt: number;
  gr_tax3per: number;
  gr_tax3amt: number;
  pr_nameed: boolean;
  value: po_mproduct;
}

interface Quantities {
  [key: string]: {
    descr: string;
    quantity: number;
    rate: number;
    discper: number;
    discamt: number;
    tax1per: number;
    tax1amt: number;
    tax2per: number;
    tax2amt: number;
    tax3per: number;
    tax3amt: number;
    printer: string;
    remarks: string;
    nameed: boolean;
    /** real product id when the cart key is a virtual excess card */
    prod?: number;
    /** portions available in the excess pool (excess cards only) */
    excessAvail?: number;
  };
}

const validationSchema = yup.object().shape({
  or_table: yup
    .number()
    .required()
    .typeError('Table No is Required?')
    .min(1, 'Select Table No'),
  or_waiter: yup
    .number()
    .required('Select Waiter Name')
    .min(1, 'Select Waiter Name'),
  or_pax: yup.number().required('Enter Pax'),
  or_mobile: yup
    .string()
    .required('Mobile is required')
    .max(10, 'Enter Correct Mobile No')
    .min(10, 'Enter Correct Mobile No'),
  or_details: yup.array().required().typeError('Select Items'),
});

const POSProduct = ({ navigation, route }: UniversalProps) => {
  const gdata: any = useSelector((state: RootState) => state.gdata);
  const { data: outletData } = useGetPOAOutletsQuery(gdata.company);
  const [search, setSearch] = useState('');
  const [group, setGroup] = useState(0);
  const [cart, setCart] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [quantities, setQuantities] = useState<Quantities>({});
  const [defOutlet, setDefOutlet] = useState(13);
  const screenWidth = Dimensions.get('window').width;

  useEffect(() => {
    const retDefOutlet = async () => {
      setDefOutlet(Number(await retrieveSetting('defoutlet')));
    };

    retDefOutlet();
  }, []);

  const outlets = outletData?.map((value, i) => {
    return {
      label: value.ol_sname,
      id: value.ol_id,
      value: value,
    };
  });

  const cid = gdata.company;

  const { data: tableData } = useGetPOMTablesQuery({
    cid: cid,
    olid: defOutlet ?? 0,
  });

  const { data: employeeData } = useGetEmployeesQuery(cid);
  const { data, refetch } = useGetPOMProductsQuery(
    {
      cid: gdata.company,
      olid: defOutlet ?? 0,
    }
  );

  useEffect(() => {
    refetch();
  }, []);

  const { data: groupData } = useGetPOMGroupsQuery({
    cid: gdata.company,
    olid: defOutlet ?? 0,
  });

  const tables: any = tableData?.map((value, key) => {
    return {
      label: value.tb_name,
      id: value.tb_id,
      table: value,
    };
  });

  const waiters: any = employeeData?.map((value, key) => {
    return {
      label: value.em_name,
      id: value.em_id,
      table: value,
    };
  });

  const sortedData = [...(Array.isArray(groupData) ? groupData : [])]?.sort(
    (a, b) =>
      (Number(a.gr_sort) <= 0 ? 9999 : a.gr_sort) -
      (Number(b.gr_sort) <= 0 ? 9999 : b.gr_sort),
  );

  const groups: any = sortedData?.map((value, _key) => {
    return {
      label: value.gr_name,
      id: value.gr_id,
      value: value,
    };
  });

  const products1: any = data?.map((value, _key) => {
    return {
      pr_group: value.pr_group,
      pr_id: value.pr_id,
      pr_name: value.pr_name,
      pr_srate: value.pr_srate,
      pr_qty: 0,
      pr_grname: value.pr_grname,
      pr_nameed: value.pr_name == '' || isOpenFoodProduct(value),
      pr_avail: value.pr_avail,
      value: value,
    };
  });

  // Excess stock pool of the outlet: each description with portions left becomes a virtual card
  // that is sold through an Open Food product, at the issued rate and capped at what is left.
  const { data: excessPool } = useGetAvailableExcessStockQuery(defOutlet ?? 0, {
    skip: !defOutlet,
  });
  const openFoodProduct: any = (products1 || []).find((p: any) =>
    isOpenFoodProduct(p.value),
  );
  const excessCards: any[] = openFoodProduct
    ? (excessPool || [])
        .filter((e: any) => Number(e.available_qty) > 0)
        .map((e: any) => ({
          pr_group: openFoodProduct.pr_group,
          pr_id: excessCartKey(openFoodProduct.pr_id, e.descr),
          pr_name: e.descr,
          pr_srate: Number(e.rate),
          pr_qty: 0,
          pr_grname: 'Excess Stock',
          pr_nameed: false,
          pr_avail: 1,
          is_excess: true,
          excess_avail: Number(e.available_qty),
          prod: openFoodProduct.pr_id,
          value: {
            ...openFoodProduct.value,
            pr_id: openFoodProduct.pr_id,
            pr_name: e.descr,
            pr_srate: Number(e.rate),
          },
        }))
    : [];
  const allProducts: any[] = [...(products1 || []), ...excessCards];

  const handleCart = (item: item, qty: number) => {
    // Get rate: use pr_srate if it's set (> 0), otherwise use user-entered rate
    let rate = 0;
    const isExcess = Boolean((item as any).is_excess);
    const isOpen = !isExcess && isOpenFoodProduct(item.value);
    const typedRate = Number(quantities[item.pr_id]?.rate) || 0;
    if (isOpen && typedRate > 0) {
      // Open Food: the rate typed by the cashier wins over the product's default
      rate = typedRate;
    } else if (Number(item.pr_srate) > 0) {
      rate = Number(item.pr_srate);
    } else {
      rate = typedRate;
    }

    if (isExcess && qty > 0) {
      const avail = Number((item as any).excess_avail || 0);
      const target = (quantities[item.pr_id]?.quantity || 0) + qty;
      if (target > avail) {
        ShowToast(
          `Only ${avail} portions of "${item.pr_name}" are left in excess stock`,
          'error',
        );
        return;
      }
    }

    // Don't add if rate is 0 and user hasn't set it yet (only when adding quantity, not removing)
    if (rate <= 0 && qty > 0 && Number(item.pr_srate) === 0) {
      ShowToast('Please enter rate first', 'error');
      return;
    }

    if ((quantities[item.pr_id]?.quantity || 0) + qty >= 0) {
      const amt = ((quantities[item.pr_id]?.quantity || 0) + qty) * rate;

      setQuantities({
        ...quantities,
        [item.pr_id]: {
          // an edited description (Open Food / unnamed products) survives +/- taps
          descr:
            item.pr_nameed && quantities[item.pr_id]?.descr
              ? quantities[item.pr_id].descr
              : item.pr_name,
          quantity: (Number(quantities[item.pr_id]?.quantity) || 0) + qty,
          rate: rate,
          discper: 0,
          discamt: 0,
          tax1per: item.value.pr_tax1,
          tax1amt: (Number(item.value.pr_tax1) * amt) / 100,
          tax2per: item.value.pr_tax2,
          tax2amt: (Number(item.value.pr_tax2) * amt) / 100,
          tax3per: item.value.pr_tax3,
          tax3amt: (Number(item.value.pr_tax3) * amt) / 100,
          printer: item.value.pr_printerip,
          nameed: item.pr_nameed,
          prod: (item as any).prod,
          excessAvail: (item as any).excess_avail,
          remarks: quantities[item.pr_id]?.remarks || '',
        },
      });
    } else {
      const newQuantities = { ...quantities };
      delete newQuantities[item.pr_id];

      setQuantities(newQuantities);
    }
  };

  const handleCartClick = () => {
    setCart(!cart);

    setGroup(0);
    setSearch('');
  };

  const [products, setProducts] = useState<any[]>([]);

  useEffect(() => {
    // Ensure products1 is defined and is an array
    if (!products1 || !Array.isArray(products1)) {
      setProducts([]);
      return;
    }

    const prods = allProducts.filter((v: any) => {
      return Number(v.pr_group) == Number(group) || Number(group) == 0;
    });

    // Sort function to order by group and name
    const sortProducts = (productList: any[]) => {
      if (
        !productList ||
        !Array.isArray(productList) ||
        productList.length === 0
      ) {
        return productList || [];
      }
      return [...productList].sort((a, b) => {
        // First sort by group
        const groupA = a.pr_grname || '';
        const groupB = b.pr_grname || '';
        if (groupA !== groupB) {
          return groupA.localeCompare(groupB);
        }
        // Then sort by product name within the same group
        const nameA = a.pr_name || '';
        const nameB = b.pr_name || '';
        return nameA.localeCompare(nameB);
      });
    };

    if (search !== '' && !isNaN(parseFloat(search)) && !cart) {
      // Search by product code - filter from group-filtered products
      const d = prods.filter((o: any) => {
        const code = o.value?.pr_code?.toString() || '';
        return code === search || code === search.toString();
      });
      setProducts(sortProducts(d));
    } else if (search.length >= 3 && !cart) {
      const options = {
        includeScore: true,
        useExtendedSearch: true,
        keys: ['pr_name'],
        threshold: 0.3, // Lower threshold for better matching
      };

      const fuse = new Fuse(prods, options);
      const b = fuse.search(search);
      const c = b.map(v => {
        return v.item;
      });

      setProducts(sortProducts(c));
    } else if (search == '') {
      const filtered = prods.filter((v: any) => {
        return (quantities?.hasOwnProperty(v.pr_id) && cart) || !cart;
      });
      setProducts(sortProducts(filtered));
    } else {
      // When search is less than 3 characters and not empty and not numeric
      const filtered = prods.filter((v: any) => {
        return (quantities?.hasOwnProperty(v.pr_id) && cart) || !cart;
      });
      setProducts(sortProducts(filtered));
    }
  }, [search, data, cart, group, products1, quantities, excessPool]);

  let initialValues: any = {
    or_id: 0,
    or_company: cid,
    or_outlet: defOutlet,
    or_date:
      moment(gdata.today).format('YYYY/MM/DD') + moment().format(' HH:mm:ss'),
    or_no: '',
    or_checkin: '',
    or_table: '',
    or_tablename: '',
    or_waiter: '',
    or_pax: '2',
    or_mobile: '0000000000',
    or_name: '',
    or_address: '',
    or_flag: 0,
    or_uid: gdata.user,
    or_cdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    or_muid: gdata.user,
    or_mdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    or_details: [],
  };

  useEffect(() => {
    if (route.params?.table?.tb_id) {
      methods.setValue('or_checkin', route.params?.table?.tb_checkin ?? '0');
      methods.setValue('or_table', route.params?.table?.tb_id ?? '0');
      methods.setValue('or_tablename', route.params?.table?.tb_name ?? '');
      methods.setValue(
        'or_pax',
        route.params?.table?.tb_capcity.toString() ?? '2',
      );
    }
  }, [tables]);

  const [defwaiter, setDefwaiter] = useState('0');

  useEffect(() => {
    const fetchdefwaiter = async () => {
      try {
        setDefwaiter(await retrieveSetting('defwaiter'));
      } catch (error) {
        console.error(error);
      }
    };

    fetchdefwaiter();

    methods.setValue('or_waiter', Number(defwaiter));
  }, []);

  useEffect(() => {
    methods.setValue('or_waiter', Number(defwaiter));
  }, [defwaiter]);

  useEffect(() => {
    if (!methods.getValues('or_waiter')) {
      methods.setValue(
        'or_waiter',
        route.params?.table?.tb_waiter ?? defwaiter,
      );
      methods.setValue(
        'or_mobile',
        route.params?.table?.tb_mobile ?? '0000000000',
      );
    }
  }, [waiters, defwaiter]);

  const { ...methods } = useForm<any>({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    methods.setValue('or_outlet', defOutlet);
  }, [defOutlet]);

  const [insertPOEOrder] = useInsertPOEOrderMutation();
  const [insertPOEOrderIdem] = useInsertPOEOrderIdemMutation();
  const [updatePOEOrder] = useUpdatePOEOrderMutation();

  const [insertPOEBill] = useInsertPOEBillMutation();

  useEffect(() => {
    // Attempt to flush any orders queued while offline as soon as we have
    // connectivity - previously nothing ever called syncOfflineQueue, so
    // orders enqueued via enqueueOrder() were never actually synced.
    const trySync = async () => {
      const result = await syncOfflineQueue(
        (order, key) => insertPOEOrderIdem({order, key}).unwrap(),
        `${gdata.company}:${gdata.user}`,
      );
      if (result.synced > 0) {
        ShowToast(`${result.synced} offline order(s) synced`, 'success');
      }
      if (result.failed > 0 && result.lastError) {
        // e.g. an excess stock limit hit while the device was offline
        ShowToast(`${result.failed} offline order(s) not synced: ${result.lastError}`, 'error');
      }
    };
    trySync();
    const unsubscribe = NetInfo.addEventListener(state => {
      if (state.isConnected) {
        trySync();
      }
    });
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit: SubmitHandler<po_eorder> = async values => {
    if (isSaving) {
      return;
    }

    try {
      let itms: po_eorderdetails[] = [];
      let i = 1;
      for (const [id, product] of Object.entries(quantities)) {
        const { descr, quantity, rate, printer, remarks } = product;

        if (quantity > 0)
          itms.push({
            od_id: 0,
            od_srid: i++,
            od_prod: product.prod ?? Number(id),
            od_descr: descr,
            od_instruct: remarks,
            od_qty: quantity,
            od_rate: rate,
            od_printer: printer,
            od_parcelcharge: '0.00',
          });
      }
      values.or_details = itms;
      values.or_date = new Date();

      // Remove quantity and remarks arrays from payload to reduce size
      const payload = values as any;
      if (payload.quantity) {
        delete payload.quantity;
      }
      if (payload.remarks) {
        delete payload.remarks;
      }

      if (values.or_details.length === 0) {
        ShowToast('Select Menu Items', 'error');
        return;
      }
      setIsSaving(true);

      // Check network state
      const online = await netState();
      if (!online) {
        // Only new orders can be queued; an edit would be replayed as a duplicate insert
        if (Number(values.or_id) !== 0) {
          ShowToast('No network. Existing orders cannot be changed offline.', 'error');
          setIsSaving(false);
          return;
        }
        // Offline: enqueue order
        await enqueueOrder(payload, `${gdata.company}:${gdata.user}`);
        ShowToast(
          'No network. Order saved offline and will sync automatically.',
          'info',
        );
        setIsSaving(false);
        methods.reset();
        setQuantities({});
        navigation.navigate('Tables');
        return;
      }

      if (Number(values.or_id) !== 0) {
        const dat: any = await updatePOEOrder(payload).unwrap();
        methods.reset();
        setQuantities({});
        ShowToast(dat.or_no + ' Updated Sucessfully');
      } else {
        const dat: any = await insertPOEOrder(payload).unwrap();
        const prnFlg = true; //await PrintReport(dat);
        methods.reset();
        setQuantities({});
        if (prnFlg) {
          ShowToast(dat.or_no + ' Saved Sucessfully');
        } else {
          ShowToast(
            dat.or_no + ' Saved Sucessfully, Unnable to Print',
            'error',
          );
        }
      }

      setIsSaving(false);
      navigation.navigate('Tables');
    } catch (e: any) {
      ShowToast(e?.data?.message || e?.message || 'Failed to save order', 'error');
      setIsSaving(false);
    }
  };

  const onError: SubmitErrorHandler<po_eorder> = (errors, e) => {
    Object.keys(errors).map((fieldName: string, i: number) => {
      // Handle form errors
    });
    return false;
  };

  const [billfooter, setBillfooter] = useState({
    stotqty: '0.00',
    stotamt: '0.00',
    totdisc: '0.00',
    tottax1: '0.00',
    tottax2: '0.00',
    tottax3: '0.00',
    roff: '0.00',
    ntotamt: '0.00',
  });

  const CalcTot = () => {
    const values = methods.getValues();
    let itms: po_ebilldetails[] = [];
    let i = 1;
    let totQty = 0,
      totAmt = 0,
      totDisc = 0,
      totTax1 = 0,
      totTax2 = 0,
      totTax3 = 0;
    for (const [id, product] of Object.entries(quantities)) {
      const {
        descr,
        quantity,
        rate,
        discper,
        discamt,
        tax1per,
        tax1amt,
        tax2per,
        tax2amt,
        tax3per,
        tax3amt,
        printer,
        remarks,
      } = product;

      if (quantity > 0) {
        totQty += Number(quantity);
        totAmt += Number(rate) * Number(quantity);
        totDisc += Number(discamt);
        totTax1 += Number(tax1amt);
        totTax2 += Number(tax2amt);
        totTax3 += Number(tax3amt);

        itms.push({
          bd_id: 0,
          bd_srid: i++,
          bd_prod: product.prod ?? Number(id),
          bd_descr: descr,
          bd_qty: Number(quantity).toFixed(2),
          bd_rate: rate.toFixed(2),
          bd_discper: discper.toFixed(2),
          bd_discamt: discamt.toFixed(2),
          bd_tax1: 1,
          bd_tax1per: tax1per.toString(),
          bd_tax1amt: tax1amt.toString(),
          bd_tax2: 2,
          bd_tax2per: tax2per.toString(),
          bd_tax2amt: tax2amt.toString(),
          bd_tax3: 3,
          bd_tax3per: tax3per.toString(),
          bd_tax3amt: tax3amt.toString(),
          bd_parcelcharge: '0.00',
        });
      }
    }
    setBillfooter({
      stotqty: totQty.toFixed(2),
      stotamt: totAmt.toFixed(2),
      totdisc: totDisc.toFixed(2),
      tottax1: totTax1.toFixed(2),
      tottax2: totTax2.toFixed(2),
      tottax3: totTax3.toFixed(2),
      roff: (
        Math.round(totAmt - totDisc + totTax1 + totTax2 + totTax3) -
        (totAmt - totDisc + totTax1 + totTax2 + totTax3)
      ).toFixed(2),
      ntotamt: Math.round(
        totAmt - totDisc + totTax1 + totTax2 + totTax3,
      ).toFixed(2),
    });
  };

  useEffect(() => {
    CalcTot();
  }, [quantities]);

  const handleBill = async (values: po_eorder) => {
    if (isSaving) {
      return;
    }
    let itms: po_ebilldetails[] = [];
    let i = 1;
    let totQty = 0,
      totAmt = 0,
      totDisc = 0,
      totTax1 = 0,
      totTax2 = 0,
      totTax3 = 0;
    for (const [id, product] of Object.entries(quantities)) {
      const {
        descr,
        quantity,
        rate,
        discper,
        discamt,
        tax1per,
        tax1amt,
        tax2per,
        tax2amt,
        tax3per,
        tax3amt,
        printer,
        remarks,
      } = product;

      if (quantity > 0) {
        totQty += quantity;
        totAmt += rate * quantity;
        totDisc += discamt;
        totTax1 += tax1amt;
        totTax2 += tax2amt;
        totTax3 += tax3amt;

        itms.push({
          bd_id: 0,
          bd_srid: i++,
          bd_prod: product.prod ?? Number(id),
          bd_descr: descr,
          bd_qty: Number(quantity).toFixed(2),
          bd_rate: rate.toFixed(2),
          bd_discper: discper.toFixed(2),
          bd_discamt: discamt.toFixed(2),
          bd_tax1: 1,
          bd_tax1per: tax1per.toString(),
          bd_tax1amt: tax1amt.toString(),
          bd_tax2: 2,
          bd_tax2per: tax2per.toString(),
          bd_tax2amt: tax2amt.toString(),
          bd_tax3: 3,
          bd_tax3per: tax3per.toString(),
          bd_tax3amt: tax3amt.toString(),
          bd_parcelcharge: '0.00',
        });
      }
    }
    const billData = {
      bl_id: 0,
      bl_company: gdata.company,
      bl_outlet: defOutlet,
      bl_date:
        moment(gdata.today).format('YYYY/MM/DD') + moment().format(' HH:mm:ss'),
      bl_no: '',
      bl_checkin: values.or_checkin,
      bl_table: values.or_table,
      bl_tablename: values.or_tablename,
      bl_waiter: values.or_waiter,
      bl_pax: values.or_pax,
      bl_mobile: values.or_mobile,
      bl_name: values.or_name,
      bl_address: values.or_address,
      bl_kotids: '',
      bl_kotnos: '',
      bl_roff: billfooter.roff,
      bl_amt: billfooter.ntotamt,
      bl_flg: 0,
      bl_uid: gdata.user,
      bl_cdt: moment().format('YYYY/MM/DD HH:mm:ss'),
      bl_muid: gdata.user,
      bl_mdt: moment().format('YYYY/MM/DD HH:mm:ss'),
      bl_details: itms,
    };

    if (Number(billfooter.ntotamt) == 0) {
      ShowToast('No Items Selected...', 'error');
      return;
    }

    setIsSaving(true);
    try {
      const dat: any = await insertPOEBill(billData).unwrap();

      methods.reset();

      ShowToast(`Bill No.${dat.bl_no} Saved Sucessfully...`);
      navigation.navigate('Tables');
    } catch (e: any) {
      ShowToast(e?.data?.message || e?.message || 'Failed to save bill', 'error');
    }
    setIsSaving(false);
  };

  const updateItemField = (field: string, text: string, itemId: string) => {
    setQuantities((prevQuantities: any) => {
      const currentItem = prevQuantities[itemId] || {
        quantity: 0,
        remarks: '',
        descr: '',
        rate: 0,
        discper: 0,
        discamt: 0,
        tax1per: 0,
        tax1amt: 0,
        tax2per: 0,
        tax2amt: 0,
        tax3per: 0,
        tax3amt: 0,
        nameed: true,
      };

      const updatedItem = {
        ...currentItem,
        [field]: field === 'rate' ? Number(text) : text,
      };

      return {
        ...prevQuantities,
        [itemId]: updatedItem,
      };
    });
  };

  // Open Food: the cashier's typed rate wins; everything else uses the product rate
  const effectiveRate = (item: any): number => {
    const typed = Number(quantities[item.pr_id]?.rate) || 0;
    if (!item.is_excess && isOpenFoodProduct(item.value) && typed > 0) return typed;
    return Number(item.pr_srate) > 0 ? Number(item.pr_srate) : typed;
  };

  const getQuantity = (item: any) => {
    return quantities[item.pr_id]?.quantity || 0;
  };

  const renderItem = (item: any, index: number, array: any[]) => {
    if (!item) return null;
    const qty = getQuantity(item);
    const showGroupHeader =
      group == 0 &&
      (index === 0 ||
        array[index - 1]?.pr_grname !== item?.pr_grname ||
        !array[index - 1]);

    return (
      <View key={item.pr_id}>
        {showGroupHeader && (
          <View style={screenStyles.groupHeader}>
            <Text style={screenStyles.groupTitle}>{item?.pr_grname}</Text>
          </View>
        )}
        <View style={screenStyles.productCard}>
          <View style={screenStyles.productHeader}>
            {item?.pr_nameed && qty > 0 ? (
              <TextInput
                name={`descr.${item.pr_id}`}
                label=""
                placeholder={tp("Product Name")}
                onChangeText={txt =>
                  updateItemField('descr', txt, item.pr_id)
                }
                style={screenStyles.nameInput}
              />
            ) : (
              <Text style={screenStyles.productName}>
                {item?.is_excess ? '⚡ ' : ''}
                {item?.pr_name}
                {item?.is_excess ? `  (${item.excess_avail} left)` : ''}
              </Text>
            )}
            <Text style={screenStyles.productPrice}>
              <T>Rs.</T> {effectiveRate(item)}
            </Text>
          </View>

          {item.pr_avail == 1 ? (
            <View style={screenStyles.quantitySection}>
              {qty === 0 ? (
                <>
                  {Number(item.pr_srate) === 0 && (
                    <View style={screenStyles.rateInputBox}>
                      <Text style={screenStyles.rateLabel}><T>Rate:</T></Text>
                      <TextInput1
                        style={screenStyles.rateInput}
                        keyboardType="numeric"
                        value={quantities[item.pr_id]?.rate?.toString() || ''}
                        onChangeText={txt =>
                          updateItemField('rate', txt, item.pr_id)
                        }
                        placeholder="0"
                      />
                    </View>
                  )}
                  <View style={screenStyles.qtyInputBox}>
                    <Text style={screenStyles.qtyLabel}><T>Qty:</T></Text>
                    <TextInput1
                      style={screenStyles.qtyInput}
                      keyboardType="numeric"
                      value={qty.toString()}
                      onChangeText={txt => {
                        const num = parseInt(txt) || 0;
                        if (num !== qty) {
                          handleCart(item, num - qty);
                        }
                      }}
                      placeholder="0"
                    />
                  </View>
                  <TouchableOpacity
                    onPress={() => handleCart(item, 1)}
                    style={screenStyles.quantityButton}
                  >
                    <Icon name="plus" size={16} color={colors.white} />
                  </TouchableOpacity>
                </>
              ) : (
                <>
                  {!item.is_excess && isOpenFoodProduct(item.value) && (
                    <View style={screenStyles.rateInputBox}>
                      <Text style={screenStyles.rateLabel}><T>Rate:</T></Text>
                      <TextInput1
                        style={screenStyles.rateInput}
                        keyboardType="numeric"
                        value={quantities[item.pr_id]?.rate?.toString() || ''}
                        onChangeText={txt =>
                          updateItemField('rate', txt, item.pr_id)
                        }
                        placeholder="0"
                      />
                    </View>
                  )}
                  <TouchableOpacity
                    onPress={() => handleCart(item, -1)}
                    style={screenStyles.quantityButton}
                  >
                    <Icon name="minus" size={16} color={colors.white} />
                  </TouchableOpacity>
                  <View style={screenStyles.quantityBox}>
                    <TextInput1
                      style={screenStyles.quantityTextInput}
                      keyboardType="numeric"
                      value={qty.toString()}
                      onChangeText={txt => {
                        const num = parseInt(txt) || 0;
                        if (num !== qty) {
                          handleCart(item, num - qty);
                        }
                      }}
                      placeholder="0"
                    />
                  </View>
                  <TouchableOpacity
                    onPress={() => handleCart(item, 1)}
                    style={screenStyles.quantityButton}
                  >
                    <Icon name="plus" size={16} color={colors.white} />
                  </TouchableOpacity>
                  <View style={screenStyles.totalPrice}>
                    <Text style={screenStyles.totalPriceText}>
                      <T>Total: Rs.</T>{' '}
                      {effectiveRate(item) * qty}
                    </Text>
                  </View>
                </>
              )}
            </View>
          ) : null}

          {qty > 0 && (
            <TextInput
              name={`remarks.${item.pr_id}`}
              label=""
              placeholder={tp("Add remarks...")}
              onChangeText={txt =>
                updateItemField('remarks', txt, item.pr_id)
              }
              style={screenStyles.remarksInput}
            />
          )}
        </View>
      </View>
    );
  };

  const [showHead, setShowHead] = useState(false);

  return (
    <View style={screenStyles.container}>
      <View style={screenStyles.header}>
        <Text style={screenStyles.headerTitle}><T>Products</T></Text>
        {Object.keys(quantities).length > 0 && (
          <View style={screenStyles.cartBadge}>
            <Text style={screenStyles.cartBadgeText}>
              {Object.keys(quantities).length}
            </Text>
          </View>
        )}
      </View>

      <FormProvider {...methods}>
        {showHead && (
          <View style={screenStyles.formSection}>
            <Row>
              <Col>
                <BTComboBox
                  name="or_table"
                  label="Table No"
                  data={tables}
                  placeholder={tp("Table No")}
                />
              </Col>
              <Col>
                <BTComboBox
                  name="or_waiter"
                  label="Captain"
                  data={waiters}
                  placeholder={tp("Waiter Name")}
                  onValChange={async (v: any) => {
                    await storeSetting('defwaiter', v.toString());
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput
                  name="or_pax"
                  label="Pax"
                  placeholder={tp("Pax")}
                  keyboardType="numeric"
                />
              </Col>
              <Col>
                <TextInput
                  name="or_mobile"
                  label="Mobile"
                  placeholder={tp("Mobile Number")}
                  keyboardType="numeric"
                />
              </Col>
            </Row>
          </View>
        )}

        {cart && (
          <View style={screenStyles.cartSummary}>
            <Text style={screenStyles.cartTitle}><T>Order Summary</T></Text>
            <View style={screenStyles.summaryRow}>
              <Text style={screenStyles.summaryLabel}><T>Total Amount</T></Text>
              <Text style={screenStyles.summaryValue}>
                <T>Rs.</T> {billfooter.ntotamt}
              </Text>
            </View>
          </View>
        )}

        <View style={screenStyles.scrollArea}>
          {!cart && (
            <View style={screenStyles.filterSection}>
              <Row>
                <Col style={{ flex: 0.4 }}>
                  <BTComboBox
                    name="group"
                    data={groups}
                    placeholder={tp("Select Group")}
                    onValChange={(v: any) => setGroup(v)}
                  />
                </Col>
                <Col style={{ flex: 0.6 }}>
                  <View style={screenStyles.searchSection}>
                    <Icon
                      name="search"
                      size={20}
                      color={colors.textTertiary}
                      style={screenStyles.searchIcon}
                    />
                    <TextInput1
                      style={screenStyles.searchInput}
                      onChangeText={setSearch}
                      value={search}
                      placeholder={tp("Search products...")}
                      placeholderTextColor={colors.textTertiary}
                    />
                  </View>
                </Col>
              </Row>
            </View>
          )}

          <FlatList
            data={products}
            renderItem={({ item, index }) => renderItem(item, index, products)}
            onEndReachedThreshold={0.1}
            contentContainerStyle={screenStyles.listContent}
            keyboardShouldPersistTaps="handled"
            showsVerticalScrollIndicator={false}
          />
        </View>
      </FormProvider>

      <View style={screenStyles.buttonRowContainer}>
        <Row>
          <Col>
            <TouchableOpacity
              style={screenStyles.iconButton}
              onPress={methods.handleSubmit(onSubmit, onError)}
              disabled={isSaving}
            >
              <Icon name="print" size={20} color={colors.white} />
              <Text style={screenStyles.iconButtonText}><T>KOT</T></Text>
            </TouchableOpacity>
          </Col>
          {gdata.menu?.find(
            (v: any) => v.mn_link == '/transaction/posettle',
          ) ? (
            <Col>
              <TouchableOpacity
                style={screenStyles.iconButton}
                onPress={() => handleBill(methods.getValues())}
                disabled={isSaving}
              >
                <Icon name="file-text-o" size={20} color={colors.white} />
                <Text style={screenStyles.iconButtonText}><T>Bill</T></Text>
              </TouchableOpacity>
            </Col>
          ) : null}
          <Col>
            <TouchableOpacity
              style={screenStyles.iconButton}
              onPress={() => {
                methods.reset();
                setQuantities({});
              }}
              disabled={isSaving}
            >
              <Icon name="trash" size={20} color={colors.white} />
              <Text style={screenStyles.iconButtonText}><T>Clear</T></Text>
            </TouchableOpacity>
          </Col>
          <Col>
            <TouchableOpacity
              style={screenStyles.iconButton}
              onPress={() => handleCartClick()}
              disabled={isSaving}
            >
              <Icon
                name={cart ? 'list' : 'shopping-cart'}
                size={20}
                color={colors.white}
              />
              <Text style={screenStyles.iconButtonText}>
                {cart ? 'View All' : 'Cart'}
              </Text>
            </TouchableOpacity>
          </Col>
          <Col>
            <TouchableOpacity
              style={screenStyles.iconButton}
              onPress={() => setShowHead(prev => !prev)}
              disabled={isSaving}
            >
              <Icon
                name={showHead ? 'chevron-up' : 'info-circle'}
                size={20}
                color={colors.white}
              />
              <Text style={screenStyles.iconButtonText}>
                {tables
                  ?.find((v: any) => v.id == methods.getValues('or_table'))
                  ?.label.substring(0, 5) || '-'}
              </Text>
            </TouchableOpacity>
          </Col>
        </Row>
      </View>
    </View>
  );
};

const screenStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.backgroundTertiary,
  },
  scrollArea: {
    flex: 1,
  },
  header: {
    backgroundColor: colors.white,
    paddingVertical: spacing.lg,
    paddingHorizontal: spacing.base,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shadows.sm,
  },
  headerTitle: {
    fontSize: typography.fontSize['3xl'],
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
  },
  cartBadge: {
    backgroundColor: colors.primary,
    borderRadius: borderRadius.full,
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cartBadgeText: {
    color: colors.white,
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
  },
  formSection: {
    backgroundColor: colors.white,
    padding: spacing.base,
    marginBottom: spacing.sm,
  },
  buttonRowContainer: {
    paddingHorizontal: spacing.base,
    paddingVertical: spacing.sm,
    backgroundColor: colors.white,
    borderTopWidth: 1,
    borderTopColor: colors.borderLight,
    ...shadows.sm,
  },
  iconButton: {
    backgroundColor: colors.primary,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.xs,
    borderRadius: borderRadius.base,
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs / 2,
    ...shadows.sm,
  },
  iconButtonText: {
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.semibold,
    color: colors.white,
    textAlign: 'center',
    marginTop: 2,
  },
  cartSummary: {
    backgroundColor: colors.white,
    padding: spacing.base,
    margin: spacing.base,
    borderRadius: borderRadius.lg,
    ...shadows.md,
  },
  cartTitle: {
    fontSize: typography.fontSize.xl,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
    marginBottom: spacing.base,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLight,
  },
  summaryLabel: {
    fontSize: typography.fontSize.base,
    color: colors.textSecondary,
    fontWeight: typography.fontWeight.medium,
  },
  summaryValue: {
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.bold,
    color: colors.primary,
  },
  filterSection: {
    backgroundColor: colors.white,
    padding: spacing.base,
    marginBottom: spacing.sm,
  },
  searchSection: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: borderRadius.lg,
    paddingHorizontal: spacing.base,
    borderWidth: 1,
    borderColor: colors.borderLight,
  },
  searchIcon: {
    marginRight: spacing.sm,
  },
  searchInput: {
    flex: 1,
    height: 50,
    fontSize: typography.fontSize.base,
    color: colors.charcoal,
  },
  listContent: {
    paddingHorizontal: spacing.sm,
    paddingBottom: spacing['5xl'],
    paddingTop: spacing.xs,
  },
  groupHeader: {
    backgroundColor: colors.backgroundSecondary,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    marginTop: spacing.xs,
    borderRadius: borderRadius.base,
  },
  groupTitle: {
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.bold,
    color: colors.primary,
  },
  productCard: {
    backgroundColor: colors.white,
    padding: spacing.sm,
    marginVertical: spacing.xs / 2,
    borderRadius: borderRadius.base,
    ...shadows.sm,
  },
  productHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: spacing.xs,
  },
  productName: {
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.semibold,
    color: colors.textPrimary,
    flex: 1,
  },
  productPrice: {
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
    color: colors.primary,
  },
  quantitySection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    marginTop: spacing.xs,
  },
  quantityButton: {
    backgroundColor: colors.primary,
    width: 32,
    height: 32,
    borderRadius: borderRadius.full,
    justifyContent: 'center',
    alignItems: 'center',
    ...shadows.sm,
  },
  quantityBox: {
    minWidth: 45,
    height: 37,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.base,
    paddingHorizontal: spacing.xs,
  },
  quantityText: {
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
  },
  quantityTextInput: {
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
    textAlign: 'center',
    width: '100%',
  },
  totalPrice: {
    marginLeft: 'auto',
  },
  totalPriceText: {
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
    color: colors.success,
  },
  nameInput: {
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLight,
  },
  remarksInput: {
    marginTop: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLight,
  },
  rateInputBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.base,
    paddingHorizontal: spacing.xs,
    paddingVertical: spacing.xs / 2,
    minWidth: 100,
  },
  rateLabel: {
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.medium,
    color: colors.textSecondary,
    marginRight: spacing.xs / 2,
  },
  rateInput: {
    flex: 1,
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
    minWidth: 50,
  },
  qtyInputBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.backgroundSecondary,
    borderRadius: borderRadius.base,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    minWidth: 100,
  },
  qtyLabel: {
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.medium,
    color: colors.textSecondary,
    marginRight: spacing.xs / 2,
  },
  qtyInput: {
    flex: 1,
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
    minWidth: 50,
  },
});

export default POSProduct;
